module.exports = __webpack_public_path__ + "static/img/img7.d7929c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/shop/img7.jpg
// module id = kp+v
// module chunks = 0